import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-notificacoes',
  templateUrl: './notificacoes.component.html',
  styleUrls: ['./notificacoes.component.scss']
})
export class NotificacoesComponent{
  @Input() notificacaoMensagens: string[] | [] = [];
  @Input() notificacaoStatus: string | 'alert-success' = 'alert-success';
  @Output() fecharNotificacoes = new EventEmitter<boolean>();



  ngAfterViewInit(){
    setTimeout(()=>{
      this.fecharNotificaoesAutomaticamente()
    }, 5000);
  }

  fecharNotificacao() {
    this.notificacaoMensagens = [];
  }

  fecharNotificaoesAutomaticamente(){
    this.notificacaoMensagens = [];
    this.fecharNotificacoes.emit(true);
  }






}
